import React, { useContext, useState } from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import CdnImageBackground from '../../common/CdnImageBackground';
import { H3 } from '../../text';
import LayoutContext from '../../../contexts/Layout';

export const LinkPanelItem = ({
    backgroundColor,
    backgroundImage,
    enableImageOverlay = false,
    followContentLink,
    index,
    link,
    linkText,
    nodeTypeAlias = 'LinkPaneltem',
    width
}) => {
    const { layout } = useContext(LayoutContext);
    const [imageDimensions, setImageDimensions] = useState();
    const textColor = backgroundColor || backgroundImage?.cdnImagePath?.length > 0 ? '#fff' : '#007bff';

    return (
        <CdnImageBackground
            enableOverlay={enableImageOverlay}
            gradientLocations={[0.0, 0.99]}
            imageDimensions={imageDimensions}
            onPress={() => link && followContentLink(link.isExternal, link.internalKey, link.externalUrl)}
            setImageDimensions={setImageDimensions}
            style={{
                backgroundColor: backgroundImage?.cdnImagePath?.length === 0 ? backgroundColor : undefined,
                justifyContent: 'center',
                marginBottom: index % 2 !== 0 ? 0 : layout.styleGuide.spacer8,
                marginRight: index % 2 === 0 ? layout.styleGuide.spacer6 : 0
            }}
            uri={backgroundImage?.cdnImagePath}
            usePointer={true}
            width={width}
            dataSet={{
                umbracoComponentName: nodeTypeAlias,
                spacerBottom: index % 2 !== 0 ? 0 : `StyleGuide.Spacer8(${layout.styleGuide.spacer8})`,
                spacerRight: index % 2 === 0 ? `StyleGuide.Spacer6(${layout.styleGuide.spacer6})` : 0
            }}
        >
            <View style={{ alignItems: 'center' }}>
                <H3 style={{ color: textColor }} text={linkText} />
            </View>
        </CdnImageBackground>
    );
};

LinkPanelItem.propTypes = {
    backgroundColor: PropTypes.string,
    backgroundImage: PropTypes.shape({
        cdnImagePath: PropTypes.string
    }),
    link: PropTypes.shape({
        externalUrl: PropTypes.string,
        internalKey: PropTypes.string,
        isExternal: PropTypes.bool
    }),
    linkText: PropTypes.string
};
